import { UploadFileField } from "@inputs/file";
import { Controller } from "react-hook-form";
import type { IAttachmentsWithCandidateDocumentsBaseProps } from "./types";

export const AttachmentsWithoutCandidateId = ({
  control,
  setAttachmentsLoading,
}: IAttachmentsWithCandidateDocumentsBaseProps) => {
  return (
    <Controller
      control={control}
      name="attachments"
      render={({ field: { onChange } }) => (
        <UploadFileField
          onChange={onChange}
          onLoading={setAttachmentsLoading}
          options={{ maxFiles: 5, maxFileSize: 26214400 }}
        />
      )}
    />
  );
};
